export const parseACLScopeValues = (scope?: string | null) => {
  if (!scope?.trim()) return [];

  return scope
    .split(/[\s,]+/)
    .map((value) => value.trim())
    .filter(Boolean);
};

export const normalizeACLScopeValue = (scope?: string | null) => {
  const normalizedScopeValues = parseACLScopeValues(scope);

  if (normalizedScopeValues.length === 0) {
    return undefined;
  }

  return normalizedScopeValues.join(" ");
};
